import { Component, ChangeDetectorRef, ViewChild } from '@angular/core';
import { BaseAppMComponent } from '../../shared/base-components/base-app-m.component';
import { CustomerService } from '../../shared/services/customer.service';
import { AdditionalCustomerData } from '../../shared/models/AdditionalCustomerData';
import { CustomerPage } from '../../shared/models/CustomerPage';
import { GlobalsService } from '../../shared/services/globals.service';
import { DQOIReferenceDataQuery } from '../../dqoi/state/dqoi-reference-data.query';
import { SaveMode } from '../../shared/enums/SaveMode';
import * as _ from 'lodash';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { InventoryService } from '../../shared/services/inventory.service';
import { GradientSettings } from '@progress/kendo-angular-inputs';
import { environment } from '../../../../environments/environment';
import { Align } from "@progress/kendo-angular-popup";
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { GeographyInfoBus } from '@app/cp/shared/models/GeographyInfoBus';
import { PotentialCustomerBus } from '@app/cp/shared/models/PotentialCustomerBus';
import { DomSanitizer } from '@angular/platform-browser';
import { GItem } from '@app/cp/shared/models/GItem';
import { PotentialLocationsComponent } from './potential-locations/potential-locations.component';
import { UseCPLoader, ICPLoader } from '@app/cp/shared/decorators/cploader/cploader-decorator';

@UseCPLoader()
@Component({
    selector: 'cp-potential-customers',
    templateUrl: './potential-customers.component.html',
    styleUrls: ['./potential-customers.component.scss'],
    standalone: false
})
export class PotentialCustomersComponent extends BaseAppMComponent<PotentialCustomerBus, CustomerService, AdditionalCustomerData, CustomerPage> {
    compLoader: ICPLoader = this as any;
    filteredStates: any[] = [];
    newCustomer: boolean = false;
    locationCBOs: GItem[] = [];
    locationActiveCBOs: GItem[];
    activeDialog: boolean = false;
    public popUp: boolean = false;
    public anchorAlign: Align = { horizontal: "right", vertical: "bottom" };
    public popupAlign: Align = { horizontal: "right", vertical: "top" };

    @ViewChild('cpPotentialLocations') public cplocations: PotentialLocationsComponent;

    public gradientSettings: GradientSettings = {
        opacity: false,
        //    clearButton: true,
    };
    subs_location: Subscription;
    subs_save: Subscription;

    depEnv: string;

    constructor(globals: GlobalsService, featureFlagService: FeatureFlagService, svc_data: CustomerService, qry_rd: DQOIReferenceDataQuery, private cd: ChangeDetectorRef, private sanitizer: DomSanitizer, private svc_inv: InventoryService) {
        super(globals, featureFlagService, qry_rd);
        this.depEnv = environment.deployment;
        this.svc_data = svc_data;
        this.addtlDataClass = "AdditionalCustomerData";
        this.pageData = new CustomerPage(svc_data, globals);
        this.saveMode = SaveMode.all;
        this.readOnly = !this.rights.MaintainCustomers;
    }

    AddPotentialCustomer() {
        this.newCustomer = true;
        this.data = {} as PotentialCustomerBus;
        this.data.geographyInfo = {} as GeographyInfoBus;
        this.data.isActive = true;
        this.setForm();
    }

    getData() {
        this.compLoader.cpLoader = true;
        if (this.id) {
            this.svc_data.getPotentialCustomer(this.id)
            .subscribe(data => {
                var pcBus: PotentialCustomerBus = new PotentialCustomerBus(data);
                this.pageData.clearAll()
                this.data = pcBus
                this.setForm();
                this.getPotentialLocations(this.id)
                this.cd.detectChanges();
                this.compLoader.cpLoader = false;
            });

        }
        else {
        }

    }

    getPotentialLocations(id: any) {
        this.subs_location = this.svc_data.getPotentialCustomerLocationsForCBO(id).subscribe(data => {
            this.locationCBOs = data;
            this.locationActiveCBOs = this.locationCBOs.filter(a => a.canSelect);
        });
    }

    setupGeographyInfo() {
        let geoInfo: GeographyInfoBus;

        if (this.data.geographyInfo) {
            geoInfo = this.data.geographyInfo;
        }

        geoInfo.addressLine1 = this.editForm.value.addressLine1;
        geoInfo.addressLine2 = this.editForm.value.addressLine2;
        geoInfo.city = this.editForm.value.city;
        geoInfo.stateProvince = this.editForm.value.stateProvince;
        geoInfo.postalCode = this.editForm.value.postalCode;
        geoInfo.countryCd = this.editForm.value.countryCd;

        return geoInfo;
    }

    setupPotentialCustomer() {
        let pcData: PotentialCustomerBus;

        if (this.data) {
            pcData = this.data;
        }

        pcData.potentialCustomerName = this.editForm.value.potentialCustomerName;
        pcData.firstName = this.editForm.value.firstName;
        pcData.lastName = this.editForm.value.lastName;
        pcData.quickSearchKey = this.editForm.value.quickSearchKey;
        pcData.workNumber = this.editForm.value.workNumber;
        pcData.workExt = this.editForm.value.workExt;
        pcData.emailAddress = this.editForm.value.emailAddress;
        pcData.mobileNumber = this.editForm.value.mobileNumber;
        pcData.faxNumber = this.editForm.value.faxNumber;

        pcData.geographyInfo = this.setupGeographyInfo();

        return pcData
    }

    customerSelected(e: any) {
        console.log("cust-cs: ", e);
        this.id = e;
        //this.mainLoadingOn(true);
        this.getData();
        this.newCustomer = false;
    }

    savePotentialCustomer() {
        this.compLoader.cpLoader = true;
        let data = this.setupPotentialCustomer();
        this.svc_data.savePotentialCustomer(data).subscribe(data => {
            this.data = data.potentialCustomer;
            this.id = this.data.potentialCustomerId;
            this.setForm();
            this.newCustomer = false;
            this.globals.notifySuccess("Potential Customer Saved Successfully!");
            this.compLoader.cpLoader = false;
        });
    }

    public editForm: UntypedFormGroup = new UntypedFormGroup({
        //Customer Tab
        'quickSearchKey': new UntypedFormControl(),
        'potentialCustomerId': new UntypedFormControl(),
        'potentialCustomerName': new UntypedFormControl(null, Validators.required),
        'firstName': new UntypedFormControl(),
        'lastName': new UntypedFormControl(),
        'insertDt': new UntypedFormControl(),
        'updateDt': new UntypedFormControl(),
        'updateUserId': new UntypedFormControl(),
        'insertUserId': new UntypedFormControl(),
        'addressLine1': new UntypedFormControl(),
        'addressLine2': new UntypedFormControl(),
        'city': new UntypedFormControl(),
        'stateProvince': new UntypedFormControl(),
        'countryCd': new UntypedFormControl(),
        'postalCode': new UntypedFormControl(),

    });

    ngAfterViewInit() {
        if (this.referenceData && this.referenceData.allStates) {
                this.filteredStates = this.referenceData.allStates
        }
        else {
            setTimeout(() => {
                if (this.referenceData && this.referenceData.allStates) {
                        this.filteredStates = this.referenceData.allStates
                }
            }, 3000);
        }
    }

    setForm() {
        if (this.data) {
            this.editForm.patchValue({
                potentialCustomerId: this.data.potentialCustomerId,
                companyId: this.data.companyId,
                potentialCustomerName: this.data.potentialCustomerName,
                firstName: this.data.firstName,
                lastName: this.data.lastName,
                quickSearchKey: this.data.quickSearchKey,
                updateUserId: this.data.updateUserId,
                insertUserId: this.data.insertUserId,
                updateDt: this.data.updateDt,
                insertDt: this.data.insertDt,
                addressLine1: this.data.geographyInfo?.addressLine1,
                addressLine2: this.data.geographyInfo?.addressLine2,
                city: this.data.geographyInfo?.city,
                stateProvince: this.data.geographyInfo?.stateProvince,
                countryCd: this.data.geographyInfo?.countryCd,
                postalCode: this.data.geographyInfo?.postalCode,
            });
        }
    }

}
